import { createFileRoute, redirect } from '@tanstack/react-router'

/** Seção sem tela própria: manda para a primeira tab. */
export const Route = createFileRoute('/_authed/pagamentos/')({
  beforeLoad: () => {
    throw redirect({ to: '/pagamentos/pagar' })
  },
})
